import moment from 'moment';

import { Flex, Text, Button, Divider } from '@workshop/ui';

import { License } from 'types/cms';

const LicensesTable = ({
  licenses,
  isMobile,
  type,
  onSelectLicense,
}: {
  licenses: License[];
  isMobile: boolean;
  type: 'created' | 'received';
  onSelectLicense: (license: License) => void;
}) => (
  <Flex flexDir="column" px={{ base: 4, md: 0 }} mb={4}>
    {licenses.length > 0 ? (
      <>
        <Flex flexDir="row" mt={6} mb={4}>
          <Flex w={{ base: '30%', md: '12.5%' }} pr={4}>
            <Text fontSize="sm" fontWeight="semibold" color="text.muted">
              Created
            </Text>
          </Flex>
          <Flex w={{ base: '35%', md: '20%' }} pr={4}>
            <Text fontSize="sm" fontWeight="semibold" color="text.muted">
              {type === 'created' ? 'Created For' : 'Created By'}
            </Text>
          </Flex>
          <Flex
            display={{ base: 'none', md: 'flex' }}
            w={{ base: '0%', md: '25%' }}
            pr={4}
          >
            <Text fontSize="sm" fontWeight="semibold" color="text.muted">
              Course(s)
            </Text>
          </Flex>
          <Flex w={{ base: '30%', md: '15%' }} pr={4}>
            <Text fontSize="sm" fontWeight="semibold" color="text.muted">
              Enrolments
            </Text>
          </Flex>
          <Flex
            display={{ base: 'none', md: 'flex' }}
            w={{ base: '0%', md: '17.5%' }}
            pr={4}
          >
            <Text fontSize="sm" fontWeight="semibold" color="text.muted">
              Expiry
            </Text>
          </Flex>
          <Flex w={{ base: '5%', md: '10%' }}></Flex>
        </Flex>
        {licenses.map((item, idx) => {
          const isLastItem = idx + 1 === licenses.length;
          return (
            <Flex flexDir="column" key={`license-${item.id}`}>
              <Divider mb={2} />
              <Flex flexDir="row" alignItems="center" pb={2}>
                <Flex w={{ base: '30%', md: '12.5%' }} pr={4}>
                  <Text fontSize="sm">
                    {moment(item.created).format("D MMM [']YY")}
                  </Text>
                </Flex>
                <Flex w={{ base: '35%', md: '20%' }} pr={4}>
                  <Text fontSize="sm" noOfLines={2}>
                    {type === 'created'
                      ? item.licensee.name
                      : item.licensor.name}
                  </Text>
                </Flex>
                <Flex
                  display={{ base: 'none', md: 'flex' }}
                  w={{ base: '0%', md: '25%' }}
                  pr={4}
                >
                  <Text fontSize="sm" noOfLines={2}>
                    {item.courses.map(
                      (course, courseIdx) =>
                        `${course.title}${
                          courseIdx + 1 === item.courses.length ? '' : ', '
                        }`
                    )}
                  </Text>
                </Flex>
                <Flex
                  w={{ base: 'auto', md: '15%' }}
                  flex={{ base: 1, md: 'none' }}
                  pr={4}
                >
                  <Text fontSize="sm">{`${
                    item.totalEnrolments - item.enrolments.length
                  } of ${item.totalEnrolments} remaining`}</Text>
                </Flex>
                <Flex display={{ base: 'none', md: 'flex' }} flex={1} pr={4}>
                  <Text
                    color={item.expiryDate ? 'text.default' : 'text.muted'}
                    fontSize="sm"
                  >
                    {item.expiryDate
                      ? moment(item.expiryDate).format("D MMM [']YY")
                      : 'None'}
                  </Text>
                </Flex>
                <Flex pr={{ base: 0, sm: 4 }} justifyContent="flex-end">
                  <Button
                    size="sm"
                    variant="ghost"
                    icon="MoreHoriz"
                    onClick={() => onSelectLicense(item)}
                  >
                    {isMobile ? '' : 'More'}
                  </Button>
                </Flex>
              </Flex>
              {isLastItem && <Divider mb="4" />}
            </Flex>
          );
        })}
      </>
    ) : (
      <Flex flexDir="column" my="6">
        <Divider mb="4" />
        <Flex pb={4}>
          <Text fontSize="sm" color="text.muted">
            None Available
          </Text>
        </Flex>
        <Divider mb="4" />
      </Flex>
    )}
  </Flex>
);
export default LicensesTable;
